import { render } from "./CollectionCreateUpdateModal.vue.js?vue&type=template&id=60417eb6!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionCreateUpdateModal.vue?vue&type=template&id=60417eb6"
import script from "./CollectionCreateUpdateModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionCreateUpdateModal.vue?vue&type=script&lang=js"
export * from "./CollectionCreateUpdateModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionCreateUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/components/CollectionCreateUpdateModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60417eb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60417eb6', __exports__)) {
    api.reload('60417eb6', __exports__)
  }
  
  module.hot.accept("./CollectionCreateUpdateModal.vue.js?vue&type=template&id=60417eb6!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionCreateUpdateModal.vue?vue&type=template&id=60417eb6", () => {
    api.rerender('60417eb6', render)
  })

}


export default __exports__